import { render, staticRenderFns } from "./SurveyResponsePage.vue?vue&type=template&id=505c9918"
import script from "./SurveyResponsePage.vue?vue&type=script&lang=js"
export * from "./SurveyResponsePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports